export default __webpack_public_path__ + "static/media/UpskillSS.3a5a7e91.svg";